<template>
  <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
    <div class="mx-auto w-full max-w-sm">
      <div>
        <img class="h-16 w-auto" src="../assets/remarketing.png" alt="Workflow">
        <h2 class="mt-6 text-3xl leading-9 font-bold text-gray-600">
          Sign in to your account
        </h2>
      </div>
      <div class="mt-8">
        <div class="mt-6">
          <div v-if="error" class="my-4 p-2 px-4 border-2 border-red-600 bg-red-200 text-red-700 rounded-lg">
              {{errorMessage}}
          </div>
          <div>
            <label for="username" class="block text-sm font-medium leading-5 text-gray-700">
              Username or Email address
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input v-model="username" id="username" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
            </div>
          </div>
          <div class="mt-6">
            <label for="password" class="block text-sm font-medium leading-5 text-gray-700">
              Password
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input v-model="password" id="password" type="password" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
            </div>
          </div>
          <div class="mt-6 flex items-center justify-between">
            <div class="flex items-center">
<!--              <input id="remember_me" type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out">-->
<!--              <label for="remember_me" class="ml-2 block text-sm leading-5 text-gray-900">-->
<!--                Remember me-->
<!--              </label>-->
            </div>
            <div class="text-sm leading-5">
              <a href="/manager/master/forgotPassword/" class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150">
                Forgot your password?
              </a>
            </div>
          </div>
          <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
            <button id="login-button" class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out" @click="login">
              <span v-if="handling"><i class="fa fa-circle-notch fa-spin"></i> Signing in</span>
              <span v-else><i class="fa fa-sign-in"></i> Sign in</span>
            </button>
          </span>
        </div>
      </div>
      <div class="px-32 mt-8 flex flex-row justify-around">
        <a href="/manager/master/selectLanguage/nl" class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150">
          NL
        </a>
        <a href="/manager/master/selectLanguage/fr" class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150">
          FR
        </a>
        <a href="/manager/master/selectLanguage/en" class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150">
          EN
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import {setContext} from "../library/session";

export default {
  name: "Login",
  data: function() {
    return {
      username: '',
      password: '',
      error: false,
      handling: false,
      errorMessage: 'Please provide correct username and password.'
    }
  },
  methods: {
    login() {
        this.error = false;
        this.handling = true;
        axios.post('/manager/api/v1/obtain-auth-token/', {username: this.username, password: this.password} ).then(response => {
            setContext(response.data);
            this.$emit('select-main', 'home')
        }).catch(error => {
            if(error.response.status===500) {
                this.errorMessage = "Unexpected error, please retry or contact the helpdesk";
                this.error = true;
            } else {
                this.errorMessage = error.response.data;
                this.error = true;
            }
        }).finally(() => {
            this.handling = false;
        });
    }
  }
};
</script>

<style scoped></style>
